import React from 'react';
import * as Yup from "yup";
import AbstractSaleDetailsForm
  from 'gui/components/editors/commons/editor/components/abstractSaleDetailsForm';
import VoucherInfo
  from 'gui/pages/mainRouter/pages/ad/components/adVoucher/components/firstStage/components/voucherDetailsCard/components/voucherInfo';
import {generateVoucherTitle} from 'gui/components/listPage/components/ad/components/adVoucher';
import {IVoucherDetails} from 'data/interfaces/products';

export interface ISaleDetails {
  askingPrice: number;
  currency: number;
  commissionPercentage: number;
}


interface ISaleDetailsFormProps {
  onSubmit: (formValues) => Promise<any>;
  voucherDetails?: IVoucherDetails;
  saleDetails?: ISaleDetails;
  setSubmitRef?: any;

  commonFormComponents?: any;
}

const SaleDetailsForm = (props: ISaleDetailsFormProps) => {
  return (<AbstractSaleDetailsForm
    {...props}
    currency={props.voucherDetails.currency}
    valuePrice={props.voucherDetails.voucherBalance}
    infoComponent={
      <VoucherInfo title={generateVoucherTitle({product: props})} product={props as any}/>
    }
  />);
};

SaleDetailsForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  HotelDetails: {},
  saleDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};
export default React.memo(SaleDetailsForm);
